/** Texto único para todos los tests de fonoaudiología en corregir-test. */
export const FONO_MARK_INCORRECTS_HINT =
  "Marca solo las respuestas incorrectas. Si fue correcta, déjala sin cambiar.";
